import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { MFELoader, useI18n } from '@jarvis/react-portal-addons';
import { IconWarningAlt } from '@veneer/core';

const MFE_REFS = {
  PRINT_ANYWHERE: '@jarvis/react-smb-print-anywhere',
};

const PrintAnywhereWidget = ({ stack }) => {
  const { t } = useI18n();
  const [retryKey, setRetryKey] = useState(0);

  const handleRetry = () => {
    setRetryKey(prevKey => prevKey + 1); // force MFELoader to remount and try loading the MFE again
  };

  return (
    <MFELoader
      key={retryKey}
      component={MFE_REFS.PRINT_ANYWHERE}
      componentMode="PrintJobs"
      data-testid="print-anywhere-widget-mfe"
      stack={stack}
      card
      header={false}
      onErrorRetryClick={handleRetry}
      i18n={{
        card: {
          loading: t('dashboard.privatePickupFiles.loadingData'),
          error: t('dashboard.error.unableLoadPrintJobs'),
          retry: t('dashboard.error.retry'),
        },
      }}
      customStyles={{
        loadingHeight: 248,
        icon: <IconWarningAlt filled />,
        border: 'outlined',
        height: 248,
        background: 'filled',
      }}
    />
  );
};

PrintAnywhereWidget.propTypes = {
  stack: PropTypes.number.isRequired,
};

export default PrintAnywhereWidget;
